import { MetricStat } from '@components/ui';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import StarIcon from '@mui/icons-material/Star';
import { useTranslation } from 'react-i18next';

import { formatRating } from './metricFormat';

const iconSx = { fontSize: 18, color: 'inherit' };

interface BuyerTopBarMetricsProps {
  ratingsCompleted?: number;
  rating?: number;
}

const BuyerTopBarMetrics = ({
  ratingsCompleted,
  rating,
}: BuyerTopBarMetricsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <MetricStat
        icon={<MonetizationOnIcon sx={iconSx} />}
        label={t('shell.completedRatings')}
        value={formatRating(ratingsCompleted)}
      />
      <MetricStat
        icon={<StarIcon sx={iconSx} />}
        label={t('shell.currentRating')}
        value={formatRating(rating)}
      />
    </>
  );
};

export default BuyerTopBarMetrics;
